import { Color } from '@types';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface CardPlanImageProps {
	opacity?: number;
}

export const CardPlanImage: React.FC<CardPlanImageProps> = ({ opacity = 1 }) => {
	return (
		<svg
			width="172"
			height="186"
			viewBox="0 0 172 186"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			opacity={opacity}
		>
			<mask
				id="mask0_1389_335678"
				style={{ maskType: 'alpha' }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="343"
				height="186"
			>
				<path
					d="M0.833984 9.00211C0.833984 4.03038 4.86436 0 9.83609 0H333.912C338.884 0 342.914 4.03038 342.914 9.00211V185.668H0.833984V9.00211Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_1389_335678)">
				<path
					d="M125.187 0C125.187 0 10.9429 0 0.330078 0V185.605L79.6141 112.194L160.147 35.3204C171.99 21.5707 170.639 10.279 171.589 0C154.528 0 154.289 0 125.187 0Z"
					fill={Color.Izibizi}
				/>
			</g>
		</svg>
	);
};
